import { Inject } from '@odinjs/odin';
import { ButtonAPI, FieldAPI, InputAPI, ToastNotificationAPI } from '@philips-internal/oswald-ui-components';
import { ToastLevel } from '@philips-internal/oswald-ui-constants';
import Controller, { OnChange, OnClick, OnClose, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { AuthenticationService, HttpService } from '@philips-internal/oswald-ui-core/lib/services';

import { ForgotPasswordAliases, FragmentNames } from '../codegen';
import { AccountRoutesAPI } from '../constants/account-routes';
import { createAndShowToastMessage } from '../utils/toast-notification-utils';

import BaseController from './BaseController';

@Controller({ fragment: FragmentNames.FORGOT_PASSWORD })
export default class ForgotPasswordController extends BaseController {

  @Inject(ForgotPasswordAliases.EMAIL_FIELD)
  emailField: FieldAPI;

  @Inject(ForgotPasswordAliases.EMAIL_INPUT)
  emailInput: InputAPI;

  @Inject(ForgotPasswordAliases.CONFIRM_BUTTON)
  confirmBtn: ButtonAPI;

  @OnMount(ForgotPasswordAliases.TOAST_NOTIFICATION_INFORMATION)
  handleToastNotificationInformationLoading(event: MountEvent): void {
    const toastNotification = event.target as ToastNotificationAPI;
    toastNotification.onClose.listen(() => toastNotification.setVisible(false));
  }

  @OnClose(ForgotPasswordAliases.ROOT_MODAL)
  onRootModalClose(): void {
    this.redirectToLogin();
  }

  @OnChange(ForgotPasswordAliases.EMAIL_FIELD)
  async onChangeEmail(): Promise<void> {
    this.confirmBtn.setEnabled(await this.emailField.isValid());
  }

  @OnClick(ForgotPasswordAliases.CONFIRM_BUTTON)
  async onClickConfirmButton(): Promise<void> {
    if (await this.isFormValid()) {
      this.confirmBtn.setEnabled(false);
      void HttpService.get(AccountRoutesAPI.USER_RECOVER_PASSWORD, { email: this.emailField.getValue() as string }, {})
        .then(response => {
          if (response.status === 200) {
            createAndShowToastMessage(
              'user.reset.password.success.message',
              ToastLevel.SUCCESS,
              undefined,
              false,
              'user.reset.password.request.success'
            );
            setTimeout(() => this.redirectToLogin(), 6000);
          }
        }).catch(() => {
          createAndShowToastMessage(
            'user.error-not-found',
            ToastLevel.ERROR,
            undefined,
            false
          );
          this.confirmBtn.setEnabled(true);
        });
    }
  }

  redirectToLogin(): void {
    if (window.location.pathname.includes('login')) return;

    AuthenticationService.redirectToLogin();
  }

  async isFormValid(): Promise<boolean> {
    return (this.emailField.isVisible() &&
      this.emailField.isValid());
  }

}
